const whyUseContentData = {
    header: {
        title: "لماذا تختار",
        subtitle: "مستر شريف اسامه",
    },
    stickyNotes: [
        {
            icon: "/images/home/whyUseSection/icon1.webp",
            title: "فيديوهات شرح",
            description: "محاضرات شرح شيقة ومتميزة واحترافية",
        },
        {
            icon: "/images/home/whyUseSection/icon3.webp",
            title: "تدريبات عمـــلية",
            description: "أسئلة تغطي كافة أجزاء المنهج و جميع المستويات",
        },
        {
            icon: "/images/home/whyUseSection/icon2.webp",
            title: "اختبارات الـــكترونية",
            description: "اختبارات جزئية و شاملة حسب النظام الحديث",
        },
    ],
};

export default whyUseContentData;
